import * as React from "react"
import Body from "../../../atoms/typography/Body"
import Line from "../../../atoms/Line"
import { getFormattedPrice } from "../../../../utils/cart-helpers"
import { HorizontalSpacer, Spacer } from "../../../atoms/spacers"
import { CartStructure } from "../../../interfaces/SaleorTypes"
import styled from "styled-components"
import H3 from "../../../atoms/typography/H3"
import H2 from "../../../atoms/typography/H2"
import RentalPriceBreakDown from "./RentalPriceBreakdown"

interface Props {
  rentalOrder: CartStructure[]
  selectedDate: string
}

const ImageContainer = styled.img`
  width: 56px;
  height: 60px;
  object-fit: contain;
`

const TitleSection = styled.div`
  display: flex;
  align-items: center;
`

const RentalOrderSummary: React.FC<Props> = ({ rentalOrder, selectedDate }) => {
  const rentalTerminalInitialFee: CartStructure | undefined = rentalOrder[0]
  const rentalTerminalMonthlyFee: CartStructure | undefined = rentalOrder[1]
  const rentalTerminalDataPackage: CartStructure | undefined = rentalOrder[2]

  const amountOfRentals = rentalTerminalInitialFee?.amount
  const rentalTerminalInitialFeePrice = rentalTerminalInitialFee?.product.variants[0].pricing.price.gross.amount
  const currency = rentalTerminalInitialFee?.product.variants[0].pricing.price.currency
  const numberOfMonths = Math.floor(rentalTerminalMonthlyFee?.amount / amountOfRentals)
  const rentalMonthlyFeePrice = rentalTerminalMonthlyFee?.product.variants[0].pricing.price.gross.amount
  const chosenDataPackage = rentalTerminalDataPackage?.product.variants[0]
  const chosenDataPackagePrice = chosenDataPackage?.pricing.price.gross.amount

  const subTotal =
    (rentalTerminalInitialFeePrice ?? 0) + numberOfMonths * (rentalMonthlyFeePrice ?? 0) + (chosenDataPackagePrice ?? 0)

  const total = amountOfRentals * subTotal

  return (
    <div>
      <Body>Satcube Instant Package</Body>
      <HorizontalSpacer spacing={0.25} />
      <Line />
      <HorizontalSpacer spacing={1.5} />
      <TitleSection>
        <ImageContainer src={rentalTerminalInitialFee?.product.media[0]?.url} />
        <Spacer spacing={1} />
        <div>
          <H3>Satcube Ku</H3>
          <Body>IQ2000 modem</Body>
        </div>
      </TitleSection>

      <RentalPriceBreakDown
        amountOfRentals={amountOfRentals}
        rentalTerminalInitialFeePrice={rentalTerminalInitialFeePrice}
        rentalMonthlyFeePrice={rentalMonthlyFeePrice}
        numberOfMonths={numberOfMonths}
        chosenDataPackage={chosenDataPackage}
        chosenDataPackagePrice={chosenDataPackagePrice}
        currency={currency}
        selectedDate={selectedDate}
        subTotal={subTotal}
      />

      <HorizontalSpacer spacing={3} />
      <H2 textAlign="center">{`Total: ${getFormattedPrice(total, currency)}`}</H2>
    </div>
  )
}

export default RentalOrderSummary
